import React from "react";

const CodeOfConduct = () => {
  return (
    <>
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn conduct-header"
        data-wow-delay="0.1s"
      >
        <div className="container text-center py-5">
          <h4 className="display-5 text-white mb-4 animated slideInDown">
            Quy tắc ứng xử
          </h4>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a href="/">Trang chủ</a>
              </li>
              <li className="breadcrumb-item text-primary" aria-current="page">
                Quy tắc ứng xử
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="styles_freeText__qCYU0 make-up-content">
              <h2>
                <strong>CƠ SỞ THIẾT LẬP VÀ PHẠM VI ÁP DỤNG</strong>
              </h2>
              <p>
                Công ty Tài chính TNHH MTV Shinhan Việt Nam (sau đây gọi là
                “SVFC” hoặc “Công ty”) hoạt động với các chính sách và thủ tục
                đảm bảo phù hợp, thống nhất với Tập đoàn tài chính Shinhan (sau
                đây gọi là “SFG”, hay gọi là “Tập đoàn”), các giá trị cốt lõi,
                chuẩn mực ứng xử và đạo đức của Shinhan Card và Công ty.
              </p>
              <p>
                Dựa trên Bộ quy tắc Đạo đức và Bộ quy tắc Ứng xử của Tập đoàn
                được áp dụng đối với tất cả nhân viên, Bộ quy tắc ứng xử và đạo
                đức (sau đây gọi là “Bộ quy tắc”) đã được xây dựng, áp dụng cho
                SVFC nhằm cung cấp cho tất cả nhân viên các bộ tiêu chuẩn đạo
                đức, ứng xử khi thực hiện các quyết định hoặc hành động trong
                các tình huống cụ thể liên quan đến công việc, cuộc sống và
                nhiệm vụ hàng ngày. Ngoài ra, các đơn vị cung cấp của Công ty,
                như đơn vị cung cấp hàng hóa và cung cấp dịch vụ cũng được
                khuyến nghị hoạt động theo Bộ quy tắc này hoặc có và hoạt động
                theo bộ chuẩn mực đạo đức tương ứng của riêng họ.
              </p>
              <h2>
                <strong>NGUYÊN TẮC CHUNG</strong>{" "}
              </h2>
              <p>
                <strong>
                  Bộ quy tắc này được áp dụng trên toàn hệ thống của SVFC bao
                  gồm tất cả các nhân viên của Công ty.
                </strong>
              </p>
              <p>
                <strong>
                  Khi nhân viên phát hiện có sự vi phạm các nội dung quy định
                  tại Bộ quy tắc này, cần phải báo cáo ngay cho cấp quản lý trực
                  tiếp hoặc các bộ phận liên quan, như là Bộ phận Pháp chế &amp;
                  Tuân thủ, Bộ phận Nhân sự
                </strong>
                <strong>. </strong>
              </p>
              <p>
                <strong>
                  Khi nhân viên đưa ra quyết định hoặc hành vi vi phạm Bộ quy
                  tắc này, nhân viên đó có thể phải chịu các hình thức xử lý kỷ
                  luật nội bộ của Công ty và / hoặc hơn nữa có thể bị điều tra
                  và xử phạt theo quy định của pháp luật.
                </strong>
              </p>
              <h3>
                <strong>
                  CHƯƠNG 1. QUY TẮC ỨNG XỬ VÀ ĐẠO ĐỨC CỦA NHÂN VIÊN
                </strong>
              </h3>
              <h3>
                <strong>Tuân thủ quy định của pháp</strong>{" "}
                <strong>
                  luật và đảm bảo tính công bằng trong hoạt động kinh doanh
                </strong>
              </h3>
              <p>
                Tất cả nhân viên của SVFC phải tôn trọng trật tự thị trường,
                tuân thủ các quy định của pháp luật có liên quan đến các lĩnh
                vực hoạt động của Công ty và phải cố gắng thực hiện công việc
                đảm bảo tính công bằng và tư cách đạo đức.
              </p>
              <p>
                Tuân thủ quy định của pháp luật và tôn trọng truyền thống, văn
                hóa của quốc gia, địa phương đó.
              </p>
              <p>
                Không được thực hiện hoặc tham gia vào hoạt động rửa tiền bất
                hợp pháp hoặc giao dịch nội gián.{" "}
              </p>
              <p>
                Không được ép buộc hoặc hướng dẫn đồng nghiệp hoặc cấp dưới thực
                hiện những công việc không đảm bảo về tính công bằng hoặc mang
                tính chất phi đạo đức và không được nhượng bộ dưới áp lực hoặc
                chỉ đạo.
              </p>
              <h3>
                <strong>Chính trực và trung thực</strong>
              </h3>
              <p>
                Tất cả nhân viên hạn chế các hoạt động đầu tư vượt quá khả năng
                tài chính của bản thân và duy trì các khoản nợ, đảm bảo xem xét
                phù hợp với khả năng trả nợ.
              </p>
              <p>
                Tất cả nhân viên phải có kiến ​​thức cơ bản về tiêu chuẩn đạo
                đức và ý thức tuân thủ pháp luật khi đã là một phần của Công ty
                và không được tham gia vào các hoạt động trái với quy định của
                pháp luật. Các hoạt động trái với quy định của pháp luật bao gồm
                nhưng không giới hạn được liệt kê vào danh sách dưới đây:
              </p>
              <p>
                {" "}
                + Chi tiêu xa đọa vượt quá khả năng tài chính của bản thân hoặc
                vượt quá mức sống của bản thân.
              </p>
              <p>
                {" "}
                + Tham gia đánh bạc, đầu cơ hoặc đến các sòng bạc vượt quá tính
                giải trí thông thường.
              </p>
              <p>
                {" "}
                + Thói quen đến những nơi có ảnh hưởng xấu như uống rượu bia quá
                mức hoặc gây mất trật tự, an toàn cho xã hội, gây ra sự bất tiện
                hoặc phản cảm cho người khác.
              </p>
              <p> + Điều khiển phương tiện đi lại khi đã uống rượu bia.</p>
              <p>
                {" "}
                + Sử dụng hoặc chi tiêu ngân sách của Công ty không hợp lý, bao
                gồm chi phí công tác và chi phí xúc tiến kinh doanh, cho bất kỳ
                mục đích nào khác ngoài mục đích chung cho Công ty.{" "}
              </p>
              <p>
                {" "}
                + Tham gia vào các hoạt động khác được cho là tương đương với
                các hoạt động trên.{" "}
              </p>
              <p>
                Tất cả nhân viên phải nhận thức rõ ràng về quyền và nghĩa vụ,
                không được cung cấp hàng hóa và dịch vụ cho khách hàng khi không
                có trình độ chuyên môn hoặc không có thẩm quyền và phải giao
                tiếp với thái độ trung thực trong khi thực hiện nhiệm vụ được
                giao.{" "}
              </p>
              <h3>
                <strong>
                  Phòng, chống rửa tiền (AML) và tài trợ khủng bố (CTF)
                </strong>
              </h3>
              <p>
                Theo quy định của pháp luật<a href="#_ftn1">[1]</a>
                và thông lệ quốc tế, hoạt động rửa tiền và tài trợ khủng bố là
                các hành vi phạm tội hình sự ở cấp độ toàn cầu. Vi phạm Luật và
                các quy định về phòng, chống rửa tiền và đấu tranh chống tài trợ
                khủng bố có thể bị xử phạt, truy cứu trách nhiệm hình sự và chịu
                các biện pháp cấm vận, hạn chế hoạt động đối với các tổ chức và
                cá nhân; thu giữ tiền và các tài sản khác; phạt tiền và phạt tù
                hoặc đình chỉ hoạt động vĩnh viễn đối với tổ chức.
              </p>
              <p>Tất cả nhân viên của SVFC được yêu cầu phải:</p>
              <p>
                Tuân thủ chính sách quy định nội bộ về Phòng, chống rửa tiền
                (AML) và tài trợ khủng bố của Công ty.{" "}
              </p>
              <p>
                Nâng cao nhận thức về phòng, chống rửa tiền và tài trợ khủng bố
                bằng cách tham gia tất cả các khóa đào tạo bắt buộc về phòng,
                chống rửa tiền và tài trợ khủng bố.{" "}
              </p>
              <p>
                Nội dung thông tin chi tiết được quy định cụ thể trong Chính
                sách quy định nội bộ về phòng, chống rửa tiền và tài trợ khủng
                bố. Trường hợp có câu hỏi về quy định, vui lòng liên hệ Bộ phận
                Pháp chế &amp; Tuân thủ để được hướng dẫn thêm.
              </p>
              <h3>
                <strong>Phòng, chống hối lộ và tham nhũng (ABC)</strong>{" "}
              </h3>
              <p>
                Đồng ý nhận hoặc biếu, tặng quà, chiêu đãi bữa ăn, hình thức
                giải trí và chi trả chi phí đi lại có thể gây ra các mâu thuẫn
                (xung đột) rõ ràng hoặc tiềm ẩn về quyền lợi hoặc dẫn đến tình
                huống mà ở đó các hành vi này được xem là hành vi hối lộ căn cứ
                theo Luật phòng, chống Tham nhũng &amp; Hối lộ và các quy định
                nội bộ của Công ty.
              </p>
              <p>
                Tất cả nhân viên của SVFC phải tuân thủ theo Luật phòng, chống
                Tham nhũng &amp; Hối lộ và quy định nội bộ của Công ty.
              </p>
              <p>
                Quà tặng, chiêu đãi bữa ăn, hình thức giải trí và chi trả chi
                phí đi lại:
              </p>
              <p>
                Phải được thực hiện với mục đích chính đáng và không được đặt
                bất cứ nghĩa vụ nào cho người nhận với ý định làm giảm tính
                khách quan của các quyết định kinh doanh với Công ty.{" "}
              </p>
              <p>
                Phải được khai báo rõ ràng, hợp lý và phù hợp với tình hình hoạt
                động kinh doanh hiện tại của Công ty và phong tục, tập quán của
                quốc gia và địa phương.{" "}
              </p>
              <p>
                Việc khai báo nhận hoặc biếu tặng quà, chiêu đãi bữa ăn, hình
                thức giải trí và chi trả chi phí đi lại được áp dụng bắt buộc
                cho tất cả nhân viên. Nội dung thông tin chi tiết được quy định
                cụ thể tại quy định nội bộ về phòng, chống Hối lộ &amp; Tham
                nhũng; tất cả nhân viên được yêu cầu đọc, hiểu và tuân thủ theo
                các quy định này. Trường hợp có câu hỏi về quy định, vui lòng
                liên hệ với bộ phận Pháp chế &amp; Tuân thủ để được hướng dẫn
                thêm.
              </p>
              <h3>
                <strong>
                  Hạn chế, ngăn ngừa mâu thuẫn (xung đột) quyền lợi (COI)
                </strong>{" "}
              </h3>
              <p>
                Tất cả nhân viên không được tạo ra các tình huống dẫn đến mâu
                thuẫn (xung đột) quyền lợi giữa Công ty và Khách hàng, và nếu
                tình huống như vậy xảy ra, phải đặt lợi ích của Công ty và Khách
                hàng lên trước nhất. Nhìn chung, tất cả nhân viên được yêu cầu
                phải:
              </p>
              <p>
                Tránh tham gia vào các hoạt động nào dẫn đến mâu thuẫn quyền lợi
                được xem là rõ ràng hoặc tiềm ẩn có thể xảy ra giữa Công ty và
                Khách hàng.{" "}
              </p>
              <p>
                Tránh các trường hợp mà các hoạt động kinh doanh của cá nhân,
                bên ngoài hoặc liên quan đến lợi ích gia đình được xem là rõ
                ràng hoặc có khả năng ảnh hưởng đến tính hợp lý của quá trình
                đưa ra quyết định của Công ty.{" "}
              </p>
              <p>
                Không được tham gia vào các hoạt động mang tính cạnh tranh với
                Công ty hoặc làm ảnh hưởng đến hiệu suất làm việc, trách nhiệm
                công việc của nhân viên đối với Công ty.{" "}
              </p>
              <p>
                Không được sử dụng thông tin bí mật, tài sản, quyền sở hữu
                (ngoại trừ trường hợp được Công ty cho phép) của Công ty và lợi
                dụng chức vụ, vị trí và quyền hạn của mình để mưu lợi cá nhân.{" "}
              </p>
              <p>
                Tất cả nhân viên phải có nghĩa vụ và trách nhiệm khai báo những
                mâu thuẫn (xung đột) về quyền lợi được xem là rõ ràng hoặc tiềm
                ẩn có thể xảy ra giữa các bên cho cấp quản lý trực tiếp hoặc các
                bộ phận liên quan như Bộ phận Nhân sự, Bộ phận Pháp chế &amp;
                Tuân thủ.{" "}
              </p>
              <p>
                Việc khai báo các mâu thuẫn về quyền lợi là áp dụng bắt buộc đối
                với nhân viên. Việc không khai báo mâu thuẫn hoặc biết nhưng
                không khai báo đều được xem là hành vi vi phạm Bộ quy tắc này
                cũng như quy định nội bộ của Công ty.{" "}
              </p>
              <p>
                Các nội dung thông tin chi tiết về mâu thuẫn quyền lợi được quy
                định cụ thể trong Chính sách quy định nội bộ về mâu thuẫn quyền
                lợi. Tất cả nhân viên được yêu cầu đọc, hiểu và tuân thủ theo
                Chính sách này. Trường hợp có câu hỏi về Chính sách, vui lòng
                liên hệ với Bộ phận Pháp chế &amp; Tuân thủ để được hướng dẫn
                thêm.{" "}
              </p>
              <h3>
                <strong>Bảo mật thông tin và An toàn thông tin</strong>{" "}
              </h3>
              <p>
                <strong>
                  Tất cả nhân viên phải quản lý và bảo vệ nghiêm ngặt thông tin
                  của Công ty và Khách hàng trong quá trình thực hiện nhiệm vụ
                  của mình
                </strong>
                <strong>:</strong>
              </p>
              <p>
                Phải bảo vệ thông tin thuộc quyền sở hữu của Công ty và thông
                tin của khách hàng được yêu cầu bảo mật (“Thông tin bí mật) theo
                quy định của pháp luật, quy định nội bộ và không được sử dụng
                cũng như không được tiết lộ các thông tin đó để mưu lợi cá nhân.
              </p>
              <p>
                Thông tin bí mật có thể hiện hữu trong bất kỳ hình thức lưu trữ
                nào hoặc có thể không có hình thức lưu trữ. Tất cả nhân viên
                không được yêu cầu thành viên khác cung cấp hoặc cấp quyền truy
                cập vào thông tin bí mật không liên quan đến công việc của bản
                thân.
              </p>
              <p>
                Nếu nhân viên duy trì hoặc sử dụng thông tin bí mật được yêu cầu
                cung cấp hoặc cấp quyền truy cập thông tin một cách bất hợp pháp
                bởi một cá nhân nội bộ hoặc bên ngoài của Công ty, nhân viên
                phải từ chối yêu cầu đó và phải giữ thông tin bí mật tách biệt
                với thông tin chung khác để quản lý chặt chẽ.{" "}
              </p>
              <p>
                Các nội dung thông tin chi tiết được thể hiện cụ thể trong Quy
                định bảo mật thông tin và chính sách nội bộ về Quản lý rủi ro
                thông tin.
              </p>
              <h3>
                <strong>Nhận thức gian lận và phòng, chống gian lận</strong>
              </h3>
              <p>Tất cả nhân viên của SVFC được yêu cầu:</p>
              <p>
                Hiểu rõ và tuân thủ quy định nội bộ về phòng chống gian lận và
                quy trình báo cáo hành vi gian lận của Công ty.{" "}
              </p>
              <p>
                Không được tham gia vào bất kỳ hoạt động gian lận nào được xem
                là rõ ràng hoặc có khả năng ảnh hưởng đến tình hình tài chính,
                thương hiệu và uy tín của Công ty.{" "}
              </p>
              <p>
                Phải ngăn chặn, hỗ trợ việc phát hiện hành vi gian lận và báo
                cáo các trường hợp khả nghi cho các cá nhân hoặc các bộ phận có
                thẩm quyền giải quyết như:{" "}
              </p>
              <ul>
                <li>Cấp quản lý trực tiếp; </li>
                <li>Phòng phòng, chống gian lận (FPU);</li>
                <li>Bộ phận Pháp chế &amp; Tuân thủ.</li>
              </ul>
              <h3>
                <strong>
                  Bảo vệ thương hiệu, tên miền và trang web của Công ty
                </strong>
              </h3>
              <p>Tất cả nhân viên của SVFC được yêu cầu:</p>
              <p>
                Hiểu rõ và tuân thủ mọi điều khoản và quy định trong tài liệu
                hướng dẫn của Công ty liên quan đến việc sử dụng tên miền,
                thương hiệu và trang web của Công ty.{" "}
              </p>
              <p>
                Đảm bảo tất cả các thông điệp có sử dụng biểu trưng (logo) và
                tên của Công ty như tờ rơi, quảng cáo, thư điện tử,… phải tuân
                theo đúng biểu mẫu và được kiểm duyệt bởi bộ phận Trải nghiệm
                khách hàng, Thương hiệu và Truyền thông trước khi đưa vào sử
                dụng chính thức.{" "}
              </p>
              <p>
                Không được phép sử dụng, minh họa và trích dẫn bất cứ tài liệu
                hoặc thông tin của Công ty trên trang mạng (web) cá nhân, các
                trang mạng (web) xã hội như Facebook, blogs và các loại hình
                khác tương ứng.
              </p>
              <p>
                Nội dung thông tin chi tiết được quy định cụ thể tại quy định
                nội bộ do Bộ phận Quản lý trải nghiệm khách hàng, thương hiệu và
                truyền thông (CX, B&amp;C) ban hành. Trường hợp có câu hỏi về
                quy định, vui lòng liên hệ Bộ phận CX, B&amp;C để được hướng dẫn
                thêm.{" "}
              </p>
              <h3>
                <strong>Bảo vệ tài sản của công ty và cơ hội kinh doanh</strong>
              </h3>
              <p>
                Tất cả nhân viên phải bảo vệ tài sản của Công ty với trách nhiệm
                kèm theo tính cẩn trọng và tuyệt đối không mưu lợi cá nhân. Tất
                cả nhân viên không được trục lợi cơ hội kinh doanh của Công ty
                mà bản thân đã nắm rõ trong quá trình thực hiện nhiệm vụ hoặc
                khi không có bên thứ ba làm việc đó.
              </p>
              <h3>
                <strong>
                  Tôn trọng lẫn nhau giữa các công ty trong Tập đoàn và nghiêm
                  cấm phân biệt đối xử
                </strong>
              </h3>
              <p>
                Tất cả nhân viên phải thể hiện sự tôn trọng lẫn nhau giữa các
                công ty trong Tập đoàn và duy trì một thể thống nhất để tối đa
                hóa sức mạnh liên kết của cả hệ thống Tập đoàn và tuyệt đối
                không phân biệt đối xử với những công ty khác trong hệ thống Tập
                đoàn.{" "}
              </p>
              <h3>
                <strong>Nghiêm cấm tham gia vào các hoạt động chính trị</strong>
              </h3>
              <p>
                Tất cả nhân viên không được tham gia vào các hoạt động chính trị
                cũng như không quyên góp hoặc đóng góp chi phí bằng hình thức
                trực tiếp hoặc gián tiếp liên quan đến các hoạt động chính trị.{" "}
                <br />
              </p>

              <h2>
                <strong>
                  CHƯƠNG 2. TIÊU CHUẨN ĐẠO ĐỨC ĐỐI VỚI KHÁCH HÀNG, NHÀ ĐẦU TƯ,
                  NHÂN VIÊN VÀ ĐƠN VỊ CUNG CẤP
                </strong>
              </h2>
              <h3>
                <strong>Khách hàng</strong>{" "}
              </h3>
              <p>
                Khách hàng phải được đối xử công bằng, cởi mở và trung thực;
              </p>
              <p>
                Sản phẩm và dịch vụ cung cấp đến khách hàng phải dễ hiểu, đáp
                ứng được nhu cầu và mang đến giá trị thực cho khách hàng;
              </p>
              <p>
                Thông tin của khách hàng phải tuyệt đối được bảo mật (trừ trường
                hợp các cơ quan chức năng yêu cầu cung cấp theo Luật định);
              </p>
              <p>
                Cung cấp và quảng bá dịch vụ cho khách hàng phải ở các mức tiêu
                chuẩn cao nhất, đồng thời thường xuyên kiểm tra rà soát nghiêm
                ngặt các tiêu chuẩn này;
              </p>
              <p>
                Đảm bảo quy trình giải quyết khiếu nại hiệu quả và kịp thời
                không gây ảnh hưởng đến quyền lợi của khách hàng cũng như hoạt
                động của Công ty.
              </p>
              <h3>
                <strong>Nhà đầu tư và nền kinh tế chung</strong>
              </h3>
              <p>
                Cung cấp thông tin trung thực và kịp thời đến nhà đầu tư nội
                dung về chiến lược, kết quả đạt được và triển vọng kinh doanh.{" "}
              </p>
              <p>
                Đảm bảo tính chính xác và độ tin cậy của dữ liệu kế toán nhằm
                phản ánh đúng đắn tình hình tài chính của Công ty và công bố các
                báo cáo tài chính để đảm bảo tính minh bạch của thông tin về
                tình hình hoạt động của Công ty.{" "}
              </p>
              <p>
                Tôn trọng các yêu cầu và đề xuất mang tính hợp pháp của các nhà
                đầu tư để xây dựng mối quan hệ tin cậy lẫn nhau.
              </p>
              <h3>
                <strong>Nhân viên công ty</strong>{" "}
              </h3>
              <p>Tất cả nhân viên có các cơ hội bình đẳng như nhau. </p>
              <p>
                Không chấp nhận bất cứ hình thức nào đối với các hành vi phân
                biệt đối xử về trình độ học vấn, nguồn gốc xuất thân, tuổi tác,
                giới tính, sắc tộc, tôn giáo, tình trạng hôn nhân, khiếm khuyết
                về thể chất hoặc mối liên hệ chính trị.
              </p>
              <p>
                Tất cả nhân viên phải tôn trọng lẫn nhau và không tham gia vào
                bất kì hành vi nào làm ảnh hưởng đến môi trường làm việc như
                quấy rối tình dục, giao dịch tiền tệ bất hợp pháp, tổ chức các
                nhóm lợi ích cá nhân hoặc nhóm có hành vi bạo lực.{" "}
              </p>
              <p>
                Có chế độ lương, thưởng hợp lý cho các nhân viên dựa trên hiệu
                suất làm việc, năng lực và duy trì các mục tiêu hoạt động nhằm
                củng cố các giá trị cốt lõi và đạt được những mục tiêu dài hạn
                của Công ty.
              </p>
              <p>
                Tăng cường đào tạo và cơ hội phát triển bản thân cho tất cả nhân
                viên.{" "}
              </p>
              <p>
                Xây dựng và khuyến khích tất cả nhân viên tham gia môi trường
                làm việc lành mạnh và thuận lợi nhằm duy trì các mối quan hệ tốt
                trong công việc.{" "}
              </p>
              <p>
                Duy trì quy trình xử lý hiệu quả cho ‘người tuýt còi’ (người dám
                can đảm tố giác) báo cáo các trường hợp vi phạm hoặc có dấu hiệu
                vi phạm quy định trong hoạt động kinh doanh.{" "}
              </p>
              <p>
                Xây dựng môi trường làm việc lành mạnh và an toàn, nhấn mạnh
                nghĩa vụ của tất cả nhân viên phải có ý thức ngăn chặn, tránh
                làm tổn hại đến các đồng nghiệp và cộng đồng xã hội.{" "}
              </p>
              <h3>
                <strong>Đơn vị cung cấp</strong>
              </h3>
              <p>
                Công ty nỗ lực xây dựng và duy trì mối quan hệ phát triển tương
                hỗ với các đơn vị cung cấp như đơn vị cung cấp hàng hóa và cung
                cấp dịch vụ và kì vọng các đơn vị cung cấp có đầy đủ sự hiểu
                biết về các nội dung và nắm bắt tinh thần, tuân thủ các nội dung
                quy định tại Bộ quy tắc này.{" "}
              </p>
              <p>
                Căn cứ và dựa trên sự phù hợp với triết lý và chính sách của
                Công ty và / hoặc Tập đoàn như tiêu chuẩn đạo đức và bảo vệ môi
                trường trong việc lựa chọn và duy trì các giao dịch với đơn vị
                cung cấp.{" "}
              </p>
              <p>
                Đảm bảo tính công bằng, bình đẳng khi thực hiện các giao dịch và
                tránh tham gia vào các hoạt động bất bình đẳng bằng cách sử dụng
                vị thế thương lượng.{" "}
              </p>
              <h2>
                <strong>
                  CHƯƠNG 3. TRÁCH NHIỆM VÀ ĐÓNG GÓP CHO CỘNG ĐỒNG VÀ XÃ HỘI
                </strong>
              </h2>
              <h3>
                <strong>Bảo vệ môi trường</strong>
              </h3>
              <p>
                <strong>
                  Bảo vệ môi trường là một yêu cầu thiết yếu để Công ty phát
                  triển bền vững và tạo lập thế hệ tương lai, Công ty đảm bảo
                  tuân thủ các quy định của pháp luật có liên quan và tham gia
                  các hoạt động để bảo vệ môi trường một cách chủ động.{" "}
                </strong>
              </p>
              <p>
                Tuân thủ quy định của pháp luật về môi trường được áp dụng trong
                các lĩnh vực hoạt động của Công ty.{" "}
              </p>
              <p>
                Tôn trọng các tiêu chuẩn và thông lệ toàn cầu về bảo vệ môi
                trường.{" "}
              </p>
              <p>
                Bảo vệ môi trường được xem là cơ sở chính để xem xét việc phát
                triển các chính sách, tiêu chuẩn và quy trình nội bộ của Công
                ty.{" "}
              </p>
              <h3>
                <strong>Tôn trọng các quyền cơ bản</strong>{" "}
              </h3>
              <p>
                <strong>
                  Công ty tôn trọng các quyền cơ bản của con người trên mọi lĩnh
                  vực hoạt động và tuân thủ các tiêu chuẩn quốc tế về các quyền
                  cơ bản.
                </strong>{" "}
              </p>
              <h3>
                <strong>Đóng góp cho cộng đồng và xã hội</strong>
              </h3>
              <p>
                Đóng góp cho các hoạt động phúc lợi và kinh tế xã hội tại các
                cộng đồng nơi chúng ta hoạt động.{" "}
              </p>
              <p>
                Khuyến khích các nhân viên tham gia vào các dự án và sáng kiến
                mang lại lợi ích cho cộng đồng và xã hội.{" "}
              </p>
              <p>
                Giảm thiểu những tác động từ hoạt động kinh doanh của Công ty có
                thể ảnh hưởng tiêu cực đến môi trường.{" "}
              </p>
              <p>
                Thực hiện các hoạt động phù hợp với truyền thống văn hóa và xã
                hội tại quốc gia, cộng đồng địa phương nơi Công ty có mạng lưới
                hoạt động.
                <br />
              </p>

              <p>
                <a href="#_ftnref1">[1]</a> Luật Phòng, chống Rửa tiền số
                07/2012/QH13 và các Nghị định, Thông tư hướng dẫn thực hiện; Bộ
                luật Hình sự 100/2015/QH13 được sửa đổi, bổ sung một số điều
                theo Luật số 12/2017/QH14 (Điều 324 – Tội Rửa tiền, Điều 300 –
                Tội Tài trợ khủng bố) và Nghị quyết Hội đồng Thẩm phán số
                03/2019/NQ-HĐTP hướng dẫn áp dụng Điều 324 của Bộ Luật Hình sự
                về tội rửa tiền.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodeOfConduct;
